import * as React from 'react'

function SlideNav(props): React.ReactElement {
  return (
    <ul className="slide-nav" {...props} />
  );
}

export default SlideNav;
